module.exports = __webpack_public_path__ + "static/media/logo-4.85a3e07d.png";